import { isLoggedInAtom } from "@/store/atoms/authAtoms";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    const isLoggedIn = context.store.get(isLoggedInAtom);

    if (isLoggedIn) {
      // If the user is logged in, redirect them from the root path ('/')
      // to their main dashboard or home page.
      throw redirect({
        to: "/payment", // <-- YOUR SPECIFIED PATH
        replace: true, // `replace` prevents the user from clicking "back" to this empty page.
      });
      
    } else {
      // If the user is not logged in, redirect them from '/' to the login page.
      throw redirect({
        to: "/login",
        replace: true,
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <div></div>;
}
